import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import {StyleRoot} from "radium";
import Login from "./components/Login";
import Style from "./style/Style";
import LoggedInRoutes from './components/LoggedInRoutes';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mode: this.getMode()
    }
  }

  componentDidMount() {
    const isDark = window.matchMedia('(prefers-color-scheme: dark)')
    isDark.addListener((event) => this.onColorSchemeChange(event));
  }

  onColorSchemeChange(e) {
    const newColorScheme = e.matches ? "dark" : "light";
    this.setState({
      mode: newColorScheme
    });
  }

  getMode() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return "dark";
    } else {
      return "light";
    }
  }

  render() {
    var style = Style.getStyle(this.getMode());

    return (
      <BrowserRouter>
        <StyleRoot>
          <Switch>
            <Route path="/login" exact render={(props) => <Login {...props} style={style}/>}/>
            <Route path="/register" exact render={(props) => <Login {...props} style={style}/>}/>
            <Route path="/" render={(props) => <LoggedInRoutes {...props} style={style}/>}/>
            
          </Switch>
        </StyleRoot>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js